module.exports = __webpack_public_path__ + "img/1.86f9589e.png";